export default __webpack_public_path__ + "static/media/certifi-5.e33ecff7.png";